
/*global jQuery, YT*/
(function ($) {
    'use strict';

    $.fn.topVideoYoutube = function (option/*, varArgs*/) {
        var args = Array.prototype.slice.call(arguments, 1);

        return this.each(function () {
            var $element = $(this);
            var ctrl = $element.data('topVideoYoutube');

            if (!ctrl) {
                var opts = $.extend({},
                    $.fn.topVideoYoutube.defaults,
                    typeof option === 'object' && option
                );

                $element.data('topVideoYoutube', (ctrl = new TopVideoYoutube(this, opts)));
            }

            if (typeof option === 'string') {
                ctrl[option].apply(ctrl, args);
            }
        });
    };

    $.fn.topVideoYoutube.defaults = {
        onEnded: null,
        onReady: null
    };

    function TopVideoYoutube(element, options) {
        this.init(element, options);
    }

    TopVideoYoutube.lastUid = 0;

    TopVideoYoutube.prototype = {
        constructor: TopVideoYoutube,

        // Properties
        uid: 0, // Unique id attached to each top video youtube instance
        player: null,
        pending: null,
        playerReady: false,

        // Methods
        /**
         * @private
         * @param {jQuery} element
         * @param {object} options
         */
        init: function (element, options) {
            this.uid = TopVideoYoutube.lastUid++;
            this.options = options;
            this.$element = $(element);
            this.onEnded = options.onEnded ? [options.onEnded] : [];
            this.onReady = options.onReady ? [options.onReady] : [];
            this.pending = {mute: false, play: false};

            this._onStateChange = this._onStateChange.bind(this);
            this._onYoutubeReady = this._onYoutubeReady.bind(this);

            hpYoutube.apiReady().then(this._postInit.bind(this));
        },

        play: function () {
            if (this.playerReady) {
                this.player.playVideo();
            } else {
                this.pending.play = true;
            }
        },

        mute: function () {
            if (this.playerReady) {
                this.player.mute();
            } else {
                this.pending.mute = true;
            }
        },

        unmute: function() {
            if (this.playerReady) {
                this.player.unMute();
            } else {
                this.pending.mute = false;
            }
        },

        destroy: function() {
            this.player = null;
        },

        get isMuted() {
            return this.player ? this.player.isMuted() : this.pending.mute;
        },

        /** @return {number} */
        get playerWidth() {
            return this.$element.find('iframe').width();
        },

        /** @return {number} */
        get playerHeight() {
            return this.$element.find('iframe').height();
        },

        _postInit: function() {
            var newPlayerId = 'top-video-youtube-' + this.uid;
            var $player = this.$element.find('#ytplayer');
            $player.prop('id', newPlayerId);

            this.player = new YT.Player(newPlayerId, {
                events: {
                    onReady: this._onYoutubeReady,
                    onStateChange: this._onStateChange
                }
            });
        },

        _applyState: function() {
            if (this.pending.play) {
                this.play();
            }

            if (this.pending.mute) {
                this.mute();
            } else {
                this.unmute();
            }

            this.pending.play = false;
            this.pending.mute = false;
        },

        /** @private */
        _onYoutubeReady: function() {
            this.playerReady = true;
            this._applyState();
            this._notifyReady();
        },

        /**
         * @param {{data: string}} newState Youtube player state
         * @private
         */
        _onStateChange: function(newState) {
            if (newState.data === YT.PlayerState.ENDED) {
                this._notifyEnded();
            }
        },

        /** @private */
        _notifyEnded: function () {
            this.$element.triggerHandler('ended');

            this.onEnded.forEach(function (callback) {
                callback(this);
            });
        },

        /** @private */
        _notifyReady: function () {
            this.onReady.forEach(function (callback) {
               callback(this);
            });
        }
    };
})(jQuery);
